import { Image } from 'react-native';

const LoginImage = ({ style }) => {
  //TODO: use PNG on the web since the SVG image is not quite the same
  return <Image source={require('./login.svg').default} style={style} />;
};

export { LoginImage };
